export const environment = {
  production: false,
  useMock: false,
  apiUrl: 'https://portal.api.dev1.aam.instantpaydev.aptyspayments.com',
  apiTokenServiceUrl: 'https://portal.api.dev1.aam.instantpaydev.aptyspayments.com',
  clientId: '9db3c035-d8cd-4562-8cef-250f4f882dda',
  mockToken:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTA5NTEwNzksImV4cCI6MTcxMDk1MTA5OSwiaWF0IjoxNzEwOTUxMDc5fQ.8kYvfIfv-dEeXClVQwOCFyobIuWZQOtWneniC5b8Enc"
};
